import { render } from "./BillingBillDetailPage.vue?vue&type=template&id=30c7d0c3&ts=true"
import script from "./BillingBillDetailPage.vue?vue&type=script&lang=ts"
export * from "./BillingBillDetailPage.vue?vue&type=script&lang=ts"

import "./BillingBillDetailPage.vue?vue&type=style&index=0&id=30c7d0c3&lang=scss"

import exportComponent from "/data/code/front/deli-front-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__